/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com
 * @since 2017.5.26
 */
let {
  Layer,
  Popup,
  DomEvent
} = L;
let {
  div: $div
} = T;
//
/**
 * 弹出层
 * @param {props,el}
 */
export default L.Popup2 = Popup.extend({
  options: {
    // 最大宽度,设置为 Infinity 居中
    maxWidth: 0,
    // // 最小宽度
    minWidth: 0,
    // 自动平移，拖动地图以便于popup的最佳显示
    autoPan: false,
    //
    autoPosition: true,
    //
    // keepInView: false,
    // 点击不关闭
    closeButton: false,
    //
    // closeOnClick: false,
    //
    autoClose: false,
    //
    // autoPanPaddingTopLeft: L.point(0, 50)
  },
  // update() {
  // 	Popup.prototype.update.call(this)
  // },
  _initLayout() {
    let that = this;
    let {
      options,
      branch
    } = that;
    let {
      leaf
    } = options;
    if (leaf && !branch) {
      // L.setOptions(that, { maxWidth: Infinity || 0, minWidth: leaf.minWidth || 0 });
      //
      let {
        className
      } = options;
      let prefix = 'leaflet-popup';
      let container = that._container = $div(prefix + ' ' + (className || '') + ' leaflet-zoom-animated');
      let contentNode = that._contentNode = $div('', container); //挂载的对象
      // 禁止滚轮和点击事件，用于拦截地图事件
      DomEvent.disableScrollPropagation(container);
      DomEvent.disableClickPropagation(container);
      // 
      leaf.el = $div();
      leaf.props = T.assign({}, leaf.props, {
        owner: that, // 弹出层对象
        marker: that._source, // 图元对象
        data: that._source && that._source.__data // 图元数据
      })
      // __vue__
      this.branch = T.render(leaf).then(vm => {
        let el = vm.$el;
        if (options.maxWidth) {
          let style = container.style;
          style.width = el.clientWidth + 'px';
          style.height = el.clientHeight + 'px';
        }
        this.setContent(el);
        return vm;
      })
    } else {
      Popup.prototype._initLayout.call(that);
    }
  },
  /**
   * 向下翻转
   */
  _getAnchor() {
    let point = Popup.prototype._getAnchor.call(this);
    let {
      _map: map,
      _contentNode: container,
      _source: marker,
      options
    } = this;
    let leaf = container.firstChild;
    // 点
    // todo 面的弹出
    if (options.autoPosition && options.leaf && leaf && marker && marker._latlng) {
      let {
        style
      } = leaf;
      style.left = style.top = '0px'; //todo，拖动位置还原
      let contentHeight = leaf.clientHeight + 20; //20 marginBottom
      let {
        x,
        y
      } = map.latLngToContainerPoint(marker._latlng);
      let size = map.getSize();
      let dx = 16,
        dy = 0;
      //
      if (container.clientHeight) {
        // 上下边界
        if (y - contentHeight < 0) {
          dy = contentHeight;
          if (y + dy > size.y) {
            dy -= (y + dy - size.y)
          }
        }
      } else {
        // 上下边界
        if (y + contentHeight > size.y) {
          dy = -contentHeight;
          if (y + dy < 0) {
            dy -= y + dy
          }
        }
      }
      // 右边界
      if (x + leaf.clientWidth > size.x) {
        dx = -leaf.clientWidth - dx;
      }
      // 
      if (dx || dy) {
        let {
          x,
          y
        } = point;
        point = [dx + x, dy + y]
      }
    }
    return point;
  }
})

/**
 * 默认初始化为Popup
 */
Layer.include({
  /**
   * 
   * @param {*} content 
   * @param {*} options 
   */
  bindPopup(content, options) {
    if (content instanceof Popup) {
      L.setOptions(content, options);
      this._popup = content;
      (content)._source = this;
    } else {
      if (!this._popup || options) {
        this._popup = new Popup(options, this);
      }
      this._popup.setContent(content);
    }

    if (!this._popupHandlersAdded) {
      let events = {
        click: this._openPopup,
        keypress: this._onKeyPress,
        remove: this.closePopup,
        move: this._movePopup
      }
      if (options && options.hover) events.mouseover = this._openPopup;
      this.on(events)
      this._popupHandlersAdded = true;
    }
    return this;
  },
  /**
   * 
   */
  unbindPopup() {
    if (this._popup) {
      this.off({
        click: this._openPopup,
        keypress: this._onKeyPress,
        remove: this.closePopup,
        move: this._movePopup
      });
      this._popupHandlersAdded = false;
      this._popup = null;
    }
    return this;
  }
})



// WEBPACK FOOTER //
// ./src/polyfill/Popup.js